export default function checkGetRetry(failureCount: number, error: Error) {
  const statusCode = (
    error as unknown as {
      statusCode: number;
    }
  )?.statusCode;

  if (statusCode >= 400 && statusCode < 500) {
    return false;
  }

  return failureCount < 3;
}
